/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

// Emits "linkified" event each time the editor changes, so
// that you can listen & update your counters

const Cls = (App.LinkifyingEditor = class LinkifyingEditor {
  static initClass() {

    this.prototype.LINK_REGEX = /((\bhttps?:\/\/)[^\r\n\s\<\,]+)|(\w+[\w\.]*\.(com?|net|org|io|gl|ly)([^\r\n\s\<\,]+)*|([^\r\n\s\<\,]+)@([^\r\n\s\<\,]+))/gim;

    this.prototype.COUPON_URL_LENGTH = 18;
  }

  // @textarea: the source of the text
  // @display:  where to show the formatted text
  constructor(textarea, display) {
    this.bind_ui = this.bind_ui.bind(this);
    this.keypressed = this.keypressed.bind(this);
    this.linkified_text = this.linkified_text.bind(this);
    this.linkified_and_imagified_text = this.linkified_and_imagified_text.bind(this);
    this.coupon_url = this.coupon_url.bind(this);
    this.has_coupon = this.has_coupon.bind(this);
    this.has_images = this.has_images.bind(this);
    this.escapeHTML = this.escapeHTML.bind(this);
    this.escapeRegExp = this.escapeRegExp.bind(this);
    this.normalize_html = this.normalize_html.bind(this);
    this.set_length = this.set_length.bind(this);
    this.emit = this.emit.bind(this);
    this.unique = this.unique.bind(this);
    this.textarea_selector = textarea;
    this.textarea = $(textarea);
    this.display  = $(display);
    this.bind_ui();
    this.keypressed();
  }


  bind_ui() {
    return this.textarea
      .off("keyup change", this.keypressed)
      .on("keyup change", this.keypressed)
      .off("counter:changed", this.keypressed)
      .on("counter:changed", this.keypressed);
  }


  keypressed() {
    const formatted_text = this.linkified_and_imagified_text(this.textarea.val());
    // App.log(`keypressed, formatted_text: >>${formatted_text}<<`);
    this.display.html(formatted_text);
    this.set_length(formatted_text);
    this.emit("linkified", {selector: this.textarea_selector});
    // return App.log("linkified");
  }


  linkified_text(text) {
    let url;
    // App.log(`linkified_text, text: >>${text}<<`);
    text    = this.normalize_html(text);
    const matches = text.match(this.LINK_REGEX);
    const escape  = this.escapeRegExp;

    if (matches) {
      // App.log("matches: ", matches);
      this.unique(matches).forEach(function(element, index, array) {
        // App.log("element: ", element);
        // App.log("index: ", index);
        // App.log("array: ", array);

        // Don't touch emails
        if (element.indexOf("@") >= 0) { return; }

        let url = element;
        if (url.indexOf("http") < 0) {
          url = "http://" + url;
        }

        // remove any trailing dots
        url = url.replace(/\.+$/g, '');

        const tag = `<a href='${url}' target='_blank'>tsig.co/abc123</a>`;
        return text = text.replace(new RegExp(escape(element), "gmi"), tag);
      });
    }

    // Add coupon url?
    if (url = this.coupon_url()) {
      text += `<a href='http://${url}' class='coupon-link' title='Coupon Link' target='_blank'>${url}</a>`;
    }

    // App.log('linkified_text returning: ', text);
    return text;
  }


  linkified_and_imagified_text(text) {
    // App.log('linkified_and_imagified_text: ', text);
    // Exclude any coupon link from the calculations
    const html = $("<div/>").html(text);
    html.find('a.coupon-link').remove();
    const raw_text = html.text();

    let max_length = App.message_modal_counter.max_chars(raw_text);
    if (this.has_images()) { max_length -= 18; }

    if (this.has_images()) {
      if (raw_text.length > max_length) {
        text = raw_text.substring(0, max_length);
        text = text.substring(0, text.lastIndexOf(" "));
        return this.linkified_text(text) + " - <a href='#' title='Images Link'>tsig.co/abc123</a>";
      } else {
        return this.linkified_text(raw_text) + " - <a href='#' title='Images Link'>tsig.co/abc123</a>";
      }

    } else {
      // App.log('linkified_and_imagified_text returning: ', this.linkified_text(text));
      return this.linkified_text(text);
    }
  }


  coupon_url() {
    // App.log('coupon_url: ', this.textarea.attr("data-coupon-url"));
    return this.textarea.attr("data-coupon-url");
  }


  has_coupon() {
    return !!this.coupon_url();
  }


  has_images() {
    return $(".js-message-images-preview-container .js-img-remove").length > 0;
  }


  escapeHTML(html) {
    return $("<div/>").text(html).html();
  }


  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }


  normalize_html(content) {
    // App.log("normalize_html before: ", content);
    content = this.escapeHTML(content);
    content = content.replace(/^/gm, "<div>");
    content = content.replace(/$/gm, "</div>");
    // App.log("normalize_html after: ", content);
    return content;
  }


  set_length(formatted_text) {
    let {
      length
    } = $("<div/>").html(formatted_text).text();
    // App.log('set_length, initial length: ', length);
    // App.log('  has_coupon? ', this.has_coupon());
    // App.log('  has_images? ', this.has_images());
    // we count coupon urls as 18 with the prepended newline
    if (this.has_coupon()) { length += 2; }
    if (this.has_images()) { length += this.COUPON_URL_LENGTH; }
    // App.log('  final length: ', length);
    return this.textarea.attr("data-formatted-length", length);
  }


  emit(event_name, payload) {
    let e = undefined;
    if (typeof CustomEvent === 'function') {
      e = new CustomEvent(event_name, {
        bubbles: true,
        cancelable: true,
        detail: payload
      });
    } else {
      e = document.createEvent('CustomEvent');
      e.initCustomEvent(event_name, true, true, payload);
    }

    // App.log("emitting: ", e);
    return document.dispatchEvent(e);
  }


  unique(arr) {
    const hash = {};
    const result = [];
    let i = 0;
    const l = arr.length;
    while (i < l) {
      if (!hash.hasOwnProperty(arr[i])) {
        //it works with objects! in FF, at least
        hash[arr[i]] = true;
        result.push(arr[i]);
      }
      ++i;
    }
    return result;
  }
});
Cls.initClass();
